import { render, staticRenderFns } from "./VideosAddUpdate.vue?vue&type=template&id=1371fde1&scoped=true&"
import script from "./VideosAddUpdate.vue?vue&type=script&lang=js&"
export * from "./VideosAddUpdate.vue?vue&type=script&lang=js&"
import style0 from "./VideosAddUpdate.vue?vue&type=style&index=0&id=1371fde1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1371fde1",
  null
  
)

export default component.exports